module.exports = __webpack_public_path__ + "static/media/kids_05.27979849.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_05.jpg
// module id = 5861
// module chunks = 0